import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components, react/prefer-stateless-function
var ConfluenceInlineComment = /*#__PURE__*/function (_Component) {
  function ConfluenceInlineComment() {
    _classCallCheck(this, ConfluenceInlineComment);
    return _callSuper(this, ConfluenceInlineComment, arguments);
  }
  _inherits(ConfluenceInlineComment, _Component);
  return _createClass(ConfluenceInlineComment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        reference = _this$props.reference,
        children = _this$props.children;
      return /*#__PURE__*/React.createElement("span", {
        "data-mark-type": "confluenceInlineComment",
        "data-reference": reference
      }, children);
    }
  }]);
}(Component);
export { ConfluenceInlineComment as default };